{
	"title": "Transakce nenalezena",
	"description": "Přejděte prosím do přehledu a zadejte platné ID transakce. ID transakce lze nalézt na prohlášení nebo na faktuře.",
	"secondaryButtonTitle": "Zobrazit úvodní stránku"
}
